import t from 'react-translate';
import { SingleMentorRequestStatus } from 'redux/schemas/models/mentor-request';

import { useMentorRequestContext } from '../mentor-request-context';
import useMentorAvailability from 'athena/hooks/use-mentor-availability';

const MentorRequestDescription = () => {
  const { request, participant, aliases } = useMentorRequestContext();
  const mentorName = participant.user.firstName;
  const mentorsAlias = aliases.mentor.downcasedPluralized;
  const { isAvailable } = useMentorAvailability(participant);

  let text = isAvailable
    ? t.MENTORING_PROGRAMS.PARTICIPANT_HOME.MENTOR_REQUEST_MODAL.MENTEE_VIEW.AVAILABLE_DESCRIPTION(mentorName)
    : t.MENTORING_PROGRAMS.PARTICIPANT_HOME.MENTOR_REQUEST_MODAL.MENTEE_VIEW.UNAVAILABLE_DESCRIPTION({
      mentorName,
      mentorsAlias,
    });

  if (request && request.state === SingleMentorRequestStatus.PENDING) {
    text = (
      t.MENTORING_PROGRAMS.PARTICIPANT_HOME.MENTOR_REQUEST_MODAL.MENTEE_VIEW.PENDING_REQUEST_DESCRIPTION(mentorName)
    );
  }

  return (
    <div className='mb-5 text-large-body gray-2'>
      {text}
    </div>
  );
};

export default MentorRequestDescription;
